var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 98.0392,
    height: 100,
    rx: 49.0196,
    fill: "#00AEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4805 34.2222L42.2805 38.5L50.0805 46.4444H19.4805V52.5556H50.0805L42.2805 60.5L46.4805 64.7778L61.4805 49.5L46.4805 34.2222ZM73.4805 70.8889H49.4805V77H73.4805C76.7805 77 79.4805 74.25 79.4805 70.8889V28.1111C79.4805 24.75 76.7805 22 73.4805 22H49.4805V28.1111H73.4805V70.8889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/Onboarding.5282c7f48d847d283802a42890b798a5.svg";
export { ForwardRef as ReactComponent };